import {
  cn,
  Modal,
  Text,
  PrimaryButton,
  DetailCard,
  Container,
  InputTextarea,
  TextButton,
  Alert,
} from '@artprov/design-system'
import { useNavigate } from 'react-router-dom'

export default function ModalValidarDatos({
  openModal,
  onCloseModal,
  mensaje = 'Mensaje en el inputTextArea',
  subtitulo = 'subtitulo',
  titulo = 'Titulo del modal',
  hintsInputMonth = [{}],
  onAcceptModal,
  disabledBtnAceptar = true,
  onRedirectToCargarNomina,
  periodo,
  empleados,
  salario_promedio,
  masa_salarial,
  ffep,
  devengado_cuota,
  total_a_pagar,
  puede_validar,
  onEliminarModal,
}) {
  const navigate = useNavigate()
  function getDetailCardWithoutIcon({ title, content }) {
    return (
      <div className={cn('w-full bg-tertiary-100 flex justify-between p-4 rounded flex-wrap gap-1 h-auto ')}>
        <Text variant="body1" className="text-primary-10 px-2">
          {title}
        </Text>
        <Text variant="body1" className="text-tertiary-10 flex items-center">
          {content}
        </Text>
      </div>
    )
  }
  return (
    <Modal.Container
      open={openModal}
      className={cn('overflow-x-hidden')}
      onClose={onCloseModal}
      closeOnClickOutside={false}
    >
      {/* <Modal.Content width={713} height={'auto'} className={cn('overflow-x-hidden')}> */}
      <Modal.Content height={'auto'} width={'auto'} className={cn('overflow-x-hidden')}>
        <Modal.Header>
          <Modal.Title className="pl-2">{titulo}</Modal.Title>
          <Modal.Close onClose={() => onCloseModal()} />
        </Modal.Header>
        <Modal.Body
          className="h-[calc(100%-100px)] py-0 w-auto"
          classNameScroll="w-auto"
          scrollX={false}
          style={{ backgroundColor: '#lightblue' }}
        >
          <Container className="xpb-0">
            {/* <div className="flex flex-col items-center"> */}
            <div className="flex flex-col ">
              <div className="grid grid-cols-12 gap-4 mb-3 h-[52px]">
                <div className="col-span-4 ">
                  <DetailCard title="Período fiscal" showIcon={false} content={periodo} vertical />
                </div>
                <div className="col-span-4">
                  <DetailCard title="Cápitas" showIcon={false} content={empleados} vertical />
                </div>
                <div className="col-span-4">
                  <DetailCard title="Masa salarial" showIcon={false} content={masa_salarial} vertical />
                </div>
              </div>
              {/* <div className="grid grid-cols-12 gap-4 mb-4 h-[52px]"> */}
              <div className="pepe grid grid-cols-12 gap-4  mt-5">
                <div className="col-span-4">
                  <DetailCard
                    showIcon={false}
                    className=" mt-5"
                    title="Salario promedio"
                    content={salario_promedio}
                    vertical
                  />
                </div>
                <div className="col-span-4">
                  <DetailCard
                    showIcon={false}
                    className=" mt-5"
                    icon="list_alt_check"
                    title="Cuota Devengada Calculada"
                    content={devengado_cuota}
                    vertical
                  />
                </div>
                <div className="col-span-4">
                  <DetailCard showIcon={false} className=" mt-5" title="Total FFEP" content={ffep} vertical />
                </div>
              </div>
              {/* <div className="grid grid-cols-12 gap-4 mb-4 mt-4 h-[52px]"> */}
              <div className="grid grid-cols-12 gap-4 mb-4 ">
                <div className="col-span-12">
                  <DetailCard showIcon={false} className="mt-5" title="Total" content={total_a_pagar} />
                  {/* {getDetailCardWithoutIcon({ title: 'Total', content: total_a_pagar })} */}
                </div>
              </div>
            </div>
          </Container>
        </Modal.Body>
        <div className="w-auto">
          {!puede_validar && (
            <Alert
              variant="warning"
              containerStyle="max-w-none "
              title={'Solo podés validar a mes vencido'}
              description={
                'No es posible validar el mes actual ni períodos futuros. La nómina se guardó como borrador para que puedas validarla en la fecha correspondiente.'
              }
              autoDismiss={false}
              iconStyle="text-warning-10"
              descriptionStyle={'break-words'}
              icon="info"
              buttonText="Volver al inicio"
              onAction={() => navigate(`/`)}
            />
          )}
        </div>
        <Modal.Footer>
          <TextButton
            size="medium"
            className="mr-1"
            onClick={() => {
              onEliminarModal()
            }}
          >
            Eliminar
          </TextButton>
          <PrimaryButton
            disabled={!puede_validar}
            className="mx-2"
            size="small"
            onClick={() => {
              onAcceptModal()
            }}
            classNameIcon="text-tertiary-100"
          >
            Validar
          </PrimaryButton>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Container>
  )
}
